import React, { PureComponent } from 'react';
import style from './style.pcss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { del } from './actions';
import config from 'config';
import { showModal } from '../modal/actions';
import ProgressBar from '../../blocks/progress-bar';

const GET_PDF_URL = `${config.serverUrl}/api/getPdf`;

@connect((state) => ({
    tasks: state.tasks
}))
class Tasks extends PureComponent { // eslint-disable-line react/prefer-stateless-function

    static displayName = '[block] tasks';

    static propTypes = {
        tasks: PropTypes.shape({
            items: PropTypes.array
        }),
        dispatch: PropTypes.func
    };

    del = (index) => (e) => {
        e.preventDefault();

        this.props.dispatch(del(index))
    };

    showPreview = ({ id }) => (e) => {
        e.preventDefault();
        const url = `${GET_PDF_URL}?preview&id=${id}__limit`;

        this.props.dispatch(showModal(url));
    };

    downloadFull = ({ id }) => (e) => {
        e.preventDefault();
        const url = `${GET_PDF_URL}?id=${id}`;

        window.location.assign(url)
    };

    render() {
        return (
            <div className={style['tasks']}>
                {this.props.tasks.items.map((task, index) => (
                    <div key={index} className={style['tasks__item']}>
                        <div className={style['tasks__label']}>
                            <div className={style['tasks__title']}>{task.title}</div>

                            <button
                                type="button" className={style['tasks__preview']}
                                onClick={this.showPreview(task)}
                                disabled={!task.id}
                            >
                                <span className={`${style['glyphicon']} ${style['glyphicon-file']}`} /> Предварительный просмотр <ins>(первые 5 страниц)</ins>
                            </button>

                            <button
                                type="button" className={style['tasks__full']}
                                onClick={this.downloadFull(task)}
                                disabled={!task.id}
                            >
                                <span className={`${style['glyphicon']} ${style['glyphicon-download']}`} /> Скачать файл для печати <ins>(все страницы)</ins>
                            </button>
                        </div>

                        <ProgressBar componentId={task.localId} />

                        <button onClick={this.del(index)} className={style['tasks__close']} />
                    </div>
                ))}
            </div>
        )
    }

}

export default Tasks;



// WEBPACK FOOTER //
// ./src/blocks/tasks/index.js